export class ConfigWordSearch {
    static WIDTH = (210 * 96) / 25.4;
    static HEIGHT = (297 * 96) / 25.4; //1122,5
}
